module.exports = __webpack_public_path__ + "media/ad_preview/iphone_placeholder_instagram-0727fb06.jpg";